var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13 .962-1.41 1.41 4.58 4.59H0v2h16.17l-4.59 4.59 1.42 1.41 7-7-7-7Z",
  fill: "#3A5325"
})));
export { SvgRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDAuOTYyNDAyTDExLjU5IDIuMzcyNEwxNi4xNyA2Ljk2MjRIMFY4Ljk2MjRIMTYuMTdMMTEuNTggMTMuNTUyNEwxMyAxNC45NjI0TDIwIDcuOTYyNEwxMyAwLjk2MjQwMloiIGZpbGw9IiMzQTUzMjUiLz4KPC9zdmc+Cg==";